// extracted by mini-css-extract-plugin
module.exports = {"columnsContainer":"PagePillar_columnsContainer__xS3Ez","leftSection":"PagePillar_leftSection__9nKOW","rightSection":"PagePillar_rightSection__Awp6l"};